















import { Component, Prop, Vue } from "vue-property-decorator";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";

@Component({
  components: {
    }
})
export default class LoadingScreen extends Vue 
{
    @Prop() title! : string;
    @Prop() message! : string

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }
}
